import { useQuery } from '@apollo/client';
import React, { useMemo } from 'react';
import { Queries } from '@shared/api';
import { i18n } from '@shared/util/i18n';
import { notNil } from '@shared/util/notNil';
import { MBChatInput as Container } from './index';

interface Props {
  cardId: string;
  channelSlug: string;
  onSend?(): void;
  onFocus?(): void;
  onBlur?(): void;
}

export function MBCardChatInput({ cardId, channelSlug, ...otherProps }: Props) {
  const { data } = useQuery<MBAPI.ChannelDetailsQuery, MBAPI.ChannelDetailsQueryVariables>(
    Queries.channel.details,
    { variables: { slug: channelSlug } },
  );
  const { data: cardData } = useQuery<MBAPI.CardChatInputQuery, MBAPI.CardChatInputQueryVariables>(
    Queries.card.chatInput,
    { variables: { id: cardId } },
  );

  const users = useMemo(() => data?.channel?.users.filter(notNil) ?? [], [data?.channel?.users]);
  const groups = useMemo(() => data?.channel?.groups.filter(notNil) ?? [], [data?.channel?.groups]);

  return (
    <Container
      {...otherProps}
      autoFocus={false}
      placeholder={i18n('chat.input.placeholder', { channelName: cardData?.card?.fields?.name })}
      draftId={`thread:${cardData?.card?.threadId}`}
      users={users}
      groups={groups}
    />
  );
}
